<template>
  <div class="main">
    <slot />
  </div>
</template>
<script lang="ts" setup>
const route = useRoute();
const isMobile = computed(() => route.query.mobile === '1');
watchEffect(() => {
  if (isMobile.value) {
    document.body.classList.add('mobile');
  } else {
    document.body.classList.remove('mobile');
  }
});
</script>
<style lang="scss">
main {
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  background: #ababab;
}
html,
body {
  min-height: 100vh;
  min-height: 100dvh;
  background: #ababab;
}
body {
  height: 100%;
  overflow-y: scroll;
  &.mobile {
    overflow: visible;
  }
}
</style>
